import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconClock', new SVGIconWithSizes(_defineProperty({}, IconSize.ExtraSmall, {
  paths: ['M8,2A6,6,0,1,1,2,8,6,6,0,0,1,8,2M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM7.9,3a1,1,0,0,0-1,1V7h-3a1,1,0,0,0,0,2h4a1,1,0,0,0,1-1V4A1,1,0,0,0,7.9,3Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));